import { graphql } from 'react-relay';

import { useQueryInterop } from '@confluence/apollo-relay-interop';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled';
import { getMonitoringClient } from '@confluence/monitoring/entry-points/getMonitoringClient';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';

import {
	type useSpaceRoleModeQuery$variables as useSpaceRoleModeQueryVariables$variables,
	type useSpaceRoleModeQuery$data as useSpaceRoleModeQuery_Query$data,
} from './__generated__/useSpaceRoleModeQuery.graphql';

export const useSpaceRoleMode = () => {
	const { cloudId } = useSessionData();
	const { data, loading } = useQueryInterop<
		useSpaceRoleModeQuery_Query$data,
		useSpaceRoleModeQueryVariables$variables
	>(
		graphql`
			query useSpaceRoleModeQuery($cloudId: ID!) {
				confluence_spaceRoleMode(cloudId: $cloudId)
			}
		`,
		{
			variables: { cloudId },
			onError: (error) => {
				getMonitoringClient().submitError(error, {
					attribution: Attribution.PERMISSIONS_EXPERIENCE,
				});
				markErrorAsHandled(error);
			},
		},
	);

	const isNotPreRoles = data?.confluence_spaceRoleMode
		? data.confluence_spaceRoleMode !== 'PRE_ROLES'
		: false;

	return {
		spaceRoleMode: data?.confluence_spaceRoleMode,
		isRbacEnabled: isNotPreRoles,
		loading,
	};
};
